<div class="document" [class.pb-5]="!print">
    @if (!print) {
        <div class="no-print quick-nav">
            <h3>Snelnavigatie</h3>
            <button
                [color]="(days?.length ?? 0) > 0 ? 'primary' : undefined"
                (click)="scrollToSection('section-days')"
                mat-raised-button
                type="button">
                Dagen
                <mat-icon
                    [matTooltip]="
                        (days?.length ?? 0) > 0 ? days!.length + ' dagen met gegevens' : 'Geen gegevens beschikbaar'
                    ">
                    {{ (days?.length ?? 0) > 0 ? 'check' : 'close' }}
                </mat-icon>
            </button>

            <button
                [color]="!noHours ? 'primary' : undefined"
                (click)="scrollToSection('section-personnel')"
                mat-raised-button
                type="button">
                Personeel
                <mat-icon [matTooltip]="!noHours ? 'Gegevens beschikbaar' : 'Geen gegevens beschikbaar'">
                    {{ !noHours ? 'check' : 'close' }}
                </mat-icon>
            </button>

            <button
                [color]="!noCars ? 'primary' : undefined"
                (click)="scrollToSection('section-cars')"
                mat-raised-button
                type="button">
                Auto's
                <mat-icon [matTooltip]="!noCars ? 'Gegevens beschikbaar' : 'Geen gegevens beschikbaar'">
                    {{ !noCars ? 'check' : 'close' }}
                </mat-icon>
            </button>

            <button
                [color]="!noHours ? 'primary' : undefined"
                (click)="scrollToSection('section-equipment')"
                mat-raised-button
                type="button">
                Materiaal
                <mat-icon [matTooltip]="!noHours ? 'Gegevens beschikbaar' : 'Geen gegevens beschikbaar'">
                    {{ !noHours ? 'check' : 'close' }}
                </mat-icon>
            </button>
        </div>
    }

    @if (fgWeekComment?.value?.comment?.length > 10 && print) {
        <div class="page">
            <table class="table">
                <tr>
                    <th>Algemene opmerkingen week {{ beginDate | date: 'w' }}</th>
                </tr>
                <tr>
                    <td>
                        <div [innerHTML]="fgWeekComment.value.comment | safeHtml"></div>
                    </td>
                </tr>
            </table>
        </div>
    }
    @if (fgWeekComment && !print && !noComments) {
        <div class="mb-5">
            <simple-tiny
                class="w-100 mb-3"
                [showMenuBar]="false"
                [content]="fgWeekComment.controls.comment"
                height="600">
            </simple-tiny>
        </div>
    }

    <div id="section-days"></div>
    @for (day of days; track day) {
        @if (
            (!noComments && day.commentsAsphalt?.length > 0) ||
            (!noComments && day.ownComment && (Roles.Asphaltexecutor | hasRole) && !print) ||
            (!noAsphalt && (day.asphalt?.length > 0 || day.adhesive?.length > 0))
        ) {
            <div class="page">
                <h2>Dagrapport asfalt {{ day.date | date: 'EEEE dd MMMM yyyy' }} {{ projectId }}</h2>
                @if (day.asphalt?.length > 0 && !noAsphalt) {
                    <h2>Asfalt</h2>
                    <app-asphalt-used-list
                        #asphaltUsedList
                        [project]="project"
                        [projectUsedAsphaltList]="day.asphalt"
                        [date]="day.date"
                        [print]="print"
                        [formsDisabled]="true"></app-asphalt-used-list>
                }
                @if (day.adhesive?.length > 0) {
                    <h2>Kleeflagen</h2>
                    <app-asphalt-used-list
                        #asphaltAdhesiveList
                        [projectUsedAsphaltList]="day.adhesive"
                        [project]="project"
                        [date]="day.date"
                        [print]="print"
                        [isAdhesive]="true"
                        [formsDisabled]="true"></app-asphalt-used-list>
                }
                @if (!noComments) {
                    @if (day.commentsAsphalt?.length > 0 || day.ownComment) {
                        @if (day.ownComment && (Roles.Asphaltexecutor | hasRole)) {
                            <simple-tiny
                                class="w-100 mb-3"
                                [showMenuBar]="false"
                                [content]="day.ownComment.controls.comment"
                                height="600">
                            </simple-tiny>
                        }
                        @if (!noComments) {
                            <table class="table">
                                @for (comment of day.commentsAsphalt; track comment) {
                                    @if (comment?.comment.length > 10) {
                                        <tr>
                                            <th>
                                                {{ comment.user?.name ?? 'Opmerkingen' }}
                                            </th>
                                            <th class="text-right" width="100">
                                                @if (!print) {
                                                    <i
                                                        class="fa fa-pencil me-3 curpoint"
                                                        (click)="editComment(comment)"></i>
                                                    <i
                                                        class="fa fa-history curpoint"
                                                        [class.changed]="comment.changed_by_count > 1"
                                                        (click)="commentHistory(comment)"></i>
                                                }
                                            </th>
                                        </tr>
                                        <tr>
                                            <td colspan="2">
                                                <div [innerHTML]="comment?.comment | safeHtml"></div>
                                            </td>
                                        </tr>
                                    }
                                }
                            </table>
                        }
                    }
                }
            </div>
        }
    }
    @if (!noComments) {
        @for (day of days; track day) {
            @if (day.comments?.length > 0 || (day.ownComment && !(Roles.Asphaltexecutor | hasRole))) {
                <div class="page">
                    <h2>Dagrapport {{ day.date | date: 'EEEE dd MMMM yyyy' }} {{ projectId }}</h2>
                    @if (day.comments?.length > 0 || day.ownComment) {
                        @if (day.ownComment && !(Roles.Asphaltexecutor | hasRole)) {
                            <simple-tiny
                                class="w-100 mb-3"
                                [showMenuBar]="false"
                                [content]="day.ownComment.controls.comment"
                                height="600">
                            </simple-tiny>
                        }
                        <table class="table">
                            @for (comment of day.comments; track comment) {
                                @if (comment?.comment.length > 10) {
                                    <tr>
                                        <th>{{ comment.user?.name ?? 'Opmerkingen' }}</th>
                                        <th class="text-right" width="100">
                                            @if (!print) {
                                                <i
                                                    class="fa fa-pencil me-3 curpoint"
                                                    (click)="editComment(comment)"></i>
                                                <i
                                                    class="fa fa-history curpoint"
                                                    [class.changed]="comment.changed_by_count > 1"
                                                    (click)="commentHistory(comment)"></i>
                                            }
                                        </th>
                                    </tr>
                                    <tr>
                                        <td colspan="2">
                                            <div [innerHTML]="comment?.comment | safeHtml"></div>
                                        </td>
                                    </tr>
                                }
                            }
                        </table>
                    }
                </div>
            }
        }
    }
    <div id="section-personnel"></div>
    @if (!noHours) {
        <app-project-week-report-hours
            [project]="project"
            [weekComment]="weekComment"
            [print]="print"
            [realisations]="realisations"
            [beginDate]="beginDate"
            [endDate]="endDate"
            [projectId]="projectId"
            [onlyWeekTotals]="onlyWeekTotals"
            [noCars]="noCars"
            (readyforpuppeteer)="readyForPuppeteer('userHoursReady')"
            (checkChanges)="checkChanges()"
            field="user_id">
        </app-project-week-report-hours>
    }

    <div id="section-cars"></div>
    @if (!noHours) {
        <app-project-week-report-hours
            [project]="project"
            [weekComment]="weekComment"
            [print]="print"
            [realisations]="realisations"
            [beginDate]="beginDate"
            [endDate]="endDate"
            [projectId]="projectId"
            [onlyWeekTotals]="onlyWeekTotals"
            (readyforpuppeteer)="readyForPuppeteer('entityHoursReady')"
            (checkChanges)="checkChanges()"
            field="entity_id">
        </app-project-week-report-hours>
    }

    <div id="section-equipment"></div>
</div>

@if (fgWeekComment && !print) {
    <div class="button-wrapper">
        <div class="container-xl">
            <div class="buttons">
                <button
                    mat-raised-button
                    color="accent"
                    routerLink="/project-dagrapport/{{ projectId }}/{{ beginDate | date: 'yyyy-MM-dd' }}">
                    Dagrapport
                </button>
                <div class="settings-menu">
                    <app-settings-menu [projectId]="project?.afas_project_id" [date]="beginDate"></app-settings-menu>
                </div>
                <button
                    [disabled]="!fgWeekComment.dirty && !faAllFcDayComment.dirty"
                    (click)="saveComment()"
                    mat-raised-button
                    color="primary">
                    {{
                        saved
                            ? 'Wijzigingen opgeslagen'
                            : fgWeekComment.dirty || faAllFcDayComment.dirty
                              ? 'Openstaande wijzigingen opslaan'
                              : 'Er zijn geen wijzigingen'
                    }}
                    @if (saving) {
                        <i class="fas fa-spinner fa-spin"></i>
                    }
                </button>
            </div>
        </div>
    </div>
}
